export default __webpack_public_path__ + "static/media/send-reply.4343fe8c.svg";